import { Observable } from 'rxjs';
import { CountriesResponse } from '../models/countries-response.model';
import { StatesResponse } from '../models/states-response.model';
import { CitiesResponse } from '../models/cities-response.model';
import { NeighborhoodsResponse } from '../models/neighborhoods-response.model';
import { ZipCodesResponse } from '../models/zipcodes-response.model';

export abstract class AddressRepository {
    abstract getCountries(): Observable<CountriesResponse>;
    abstract getStates(countryId: number): Observable<StatesResponse>;
    abstract getCities(stateId: number): Observable<CitiesResponse>;
    abstract getNeighborhoods(
        cityId: number,
    ): Observable<NeighborhoodsResponse>;
}
